<template>
    <div>
        <about-slider></about-slider>

        <div class="eg">
            <content-item :title="$t('about')">
                <div class="about-eg">
                    <p>{{ $t('aboutEgP1') }}</p>
                </div>
            </content-item>
        </div>

        <history></history>
    </div>
</template>

<script>
    import AboutSlider from './about/AboutSlider.vue'
    import ContentItem from './partial/ContentItem.vue'
    import History from './about/History.vue'

    export default {
        components: {
            ContentItem,
            AboutSlider,
            History
        }
    }
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
    @import "../assets/scss/lib.scss";

    .eg {
        margin-top: 30px;
    }

    .about-eg {
        line-height: 25px;
        color: #616161;
        font-size: 16px;
        padding: 0 35px;
        p:last-child {
            margin-top: 10px;
        }
    }
</style>


// WEBPACK FOOTER //
// About.vue?4706d067